import { Controller } from "@hotwired/stimulus"

// Shows only the filter groups that apply to the selected product type on
// the Products workspace. Filters apply on Run rather than on change, so
// this narrows the visible controls in the browser instead of reloading.
// Hidden controls keep their values: switching back to a type (or to all)
// brings its filters back exactly as the user left them.
export default class extends Controller {
  static targets = ["typeSelect", "group"]

  connect() {
    this.typeChanged()
  }

  typeChanged() {
    const type = this.typeSelectTarget.value

    this.groupTargets.forEach(group => {
      const applies = !type || group.dataset.productType === type
      group.classList.toggle("d-none", !applies)
    })
  }
}
